import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14 9.667V14a1.333 1.333 0 0 1-1.333 1.333H4A1.333 1.333 0 0 1 2.667 14V5.333A1.333 1.333 0 0 1 4 4h4.333M11.333 2.667h4v4M7.667 10.333 15.333 2.667",
      stroke: "currentColor",
      "stroke-width": "1.33",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }